import React, { useEffect, useLayoutEffect, useState } from "react"
import getSearchParam from "@ecom/ui/utils/getSearchParam"
import { HeaderWithBurger } from "@ecom/ui/components/Header/HeaderWithBurger"
import Layout, { PageLayoutProps } from "../components/Layouts/mainPage"
import { BannerProps } from "../components/Seo/Banner"
import { Breadcrumbs } from "../components/Breadcrumbs"
import { HowInstallmentWorks } from "../components/HowInstallmentWorks"
import { Form } from "../components/Seo/Form"
import { SwitcherTextBlock } from "../components/SwitcherTextBlock"
import { NewSeoOtherOffers } from "../components/NewSeoOtherOffers"
import { BannerWithAdvantages, ImgSeoRefin } from "../components/Banners/BannerWithAdvantages"

import { FourAdvantagesPoints } from "../components/FourAdvantagesPoints"
import { MoreBenefitsRedisign } from "../components/MorBenefitsRedisgn"
import { BottomCta, RefinSeoBgImg } from "../components/BottomCta"
import { NewFooter } from "../components/NewFooter"

import creditTags from "../static/creditTags.json"

import { renderLinkList } from "./helpers/renderLinkList"
import { createSeoData } from "./helpers/createSeoData"

import { NewHeader } from "../components/Headers/NewHeader"
import { useHybridBanner } from "../hooks/useHybridBanner"
import { handleClickHeader } from "../helpers/WatcherDL/utils/handleClickHeader"
import headerLinksV2 from "../data/dataHeader/headerLinksV2.json"
import { RedHalvaWithSovcombank } from "../components/Headers/Logos"
import { CalculatorWithForm } from "../components/CalculatorWithForm"
import { ICalcConfig } from "../components/CalculatorWithForm/types"
import { DLClickEventExtended } from "../helpers/WatcherDL/DLEvents"

const calcConfig: ICalcConfig = {
  term: 24,
  loanAmountConfig: {
    initialValue: 100000,
    min: 10000,
    max: 300000,
    step: 1000,
  },
  payMonthlyConfig: {
    initialValue: 9700,
    min: 1000,
    max: 30000,
    step: 500,
  },
}

const FORM_TITLE = "Оформите карту «Халва»"
const FORM_SUBTITLE = "Быстрая и бесплатная доставка или самовывоз"
const FORM_BTN_TEXT = "Оформить карту"
const HOW_INSTALLMENT_WORKS_TITLE = (
  <>
    Рефинансируйте
    <br />с Халвой
  </>
)

const MORE_BENEFITS_TITLE = (
  <>
    Преимущества
    <br />
    рефинансирования с Xалвой
  </>
)
const GIFT_TITLE = (
  <>
    <b>Оформите Халву</b>
    <br />
    для&nbsp;удобного&nbsp;рефинансирования
  </>
)

interface Tags {
  name: string
  seos?: {
    shortTitle: string
    url: string
  }[]
}

type Props = {
  pageContext: {
    url: string
    title: PageLayoutProps["title"]
    shortTitle?: string
    description: PageLayoutProps["description"]
    upperBannerText: BannerProps["html"]
    remoteImage: BannerProps["large"]
    remoteImageMob: BannerProps["mob"]
    seoBlockText?: string
    shortSeoBlockText: string
    phones?: string[]
    noIndex: boolean
    hasOtherPercents: boolean
    ligal: string
    variables: {
      halvaOstatok: {
        value: string
      }
    }
  }
}

export default function Seo({ pageContext }: Props) {
  const {
    upperBannerText,
    url,
    title,
    shortTitle,
    description,
    shortSeoBlockText,
    noIndex,
    ligal,
  } = pageContext
  const isCreditCart = url.includes("/halva/refinansirovanie-kreditnoy-karty/")

  const isBlackText =
    isCreditCart && getSearchParam("bn") === "refin_2_26" && getSearchParam("h") === "refin_2_26"

  const [hasExclude, setHasExclude] = useState(false)

  useLayoutEffect(() => {
    setHasExclude(getSearchParam("exclude") === "99-1-9")
  }, [])

  const otherOffersTags: Tags[] = creditTags
  const otherOffersTitle: string = "Другие предложения по картам"
  const breakpointColumnsObj: any = {
    default: 4,
    1279: 3,
    959: 2,
    599: 1,
  }

  const [isTestActive, setIsTestActive] = useState(false)

  useEffect(() => {
    if ((globalThis as any).KameleoonExperiment_270385 === 1022351) {
      setIsTestActive(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(globalThis as any).KameleoonExperiment_270385 === 1022351])

  // const { titleHtml, descriptionHtml } = parseBannerHtmlSeo(upperBannerText)

  const banner = useHybridBanner(
    BannerWithAdvantages as any,
    {
      title: "Рефинансирование<br/>кредиток на&nbsp;24&nbsp;месяца",
      desc: "по карте Халва",
    },
    {
      Img: ImgSeoRefin,
      orderNum: "2",
      buttonFloating: getSearchParam("exclude") === "99-1-9",
      variant: "refinMedia",
      variantStyle: "pkwRefin",
    },
    isBlackText
      ? { orderNum: "2", variantStyle: "refinBlack", isAdvantages: true, advantagesData: "refin" }
      : { orderNum: "2" }
  )

  const linkList = renderLinkList(url, shortTitle)

  const seoData = createSeoData(title, description, upperBannerText, url, shortTitle)

  // Получение первой страницы на которую зашел
  useEffect(() => {
    if (!sessionStorage.getItem("firstURL")) {
      sessionStorage.setItem("firstURL", document.URL)
    }
  }, [])

  const onClick = () => {
    DLClickEventExtended({ name: "Логотип", eventAction: "Клик на логотип", placement: "header" })
    window.open("https://halvacard.ru/", "_blank")
  }

  return (
    <Layout noHeader noFooter seoData={seoData} noIndex={noIndex} ligal={ligal}>
      {hasExclude ? (
        <NewHeader redLogoWithSovcombank showHint={false} hasCTA />
      ) : (
        <HeaderWithBurger
          Logo={RedHalvaWithSovcombank}
          onLogoClick={onClick}
          onSidebarBtnClick={() => handleClickHeader("click_cta", "burger_menu")}
          onHeaderBtnClick={() => handleClickHeader("click_cta", "header")}
          orderNum="99"
          listLinksForNav={headerLinksV2}
          anotherStylesTypeV2
        />
      )}
      {linkList && <Breadcrumbs linkList={linkList} orderNum="1" />}
      {banner}
      {isTestActive && <CalculatorWithForm config={calcConfig} subtitle="" />}

      <FourAdvantagesPoints variant="refin" orderNum="3" />
      <HowInstallmentWorks
        variant="refinKreditnoyKarty"
        headTitle={HOW_INSTALLMENT_WORKS_TITLE}
        orderNum="4"
      />
      <Form
        progressBar={isCreditCart}
        isGreenApprove={isCreditCart}
        variant="refin"
        noWoman
        title={FORM_TITLE}
        subtitle={FORM_SUBTITLE}
        formBtnText={FORM_BTN_TEXT}
        dataLayerName="shortPersonalForm"
        orderNum="5"
      />
      <MoreBenefitsRedisign
        variant="refinSeo"
        bottomBlock={false}
        additionalEventInDataLayer
        title={MORE_BENEFITS_TITLE}
        hasSubtitle={false}
        orderNum="6"
      />
      <SwitcherTextBlock mode="refin" seoBlockText={shortSeoBlockText} orderNum="7" />
      <BottomCta variant="refin" title={GIFT_TITLE} BgImg={RefinSeoBgImg} orderNum="8" />
      {otherOffersTags && (
        <NewSeoOtherOffers
          variant="refin"
          title={otherOffersTitle}
          tags={otherOffersTags}
          breakpointColumnsObj={breakpointColumnsObj}
          orderNum="9"
        />
      )}
      <NewFooter ligal={ligal} />
    </Layout>
  )
}
